import { render, staticRenderFns } from "./AddRulesChooseShopsDialog.vue?vue&type=template&id=1cd8e329&scoped=true"
import script from "./AddRulesChooseShopsDialog.vue?vue&type=script&lang=ts"
export * from "./AddRulesChooseShopsDialog.vue?vue&type=script&lang=ts"
import style0 from "./AddRulesChooseShopsDialog.vue?vue&type=style&index=0&id=1cd8e329&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd8e329",
  null
  
)

export default component.exports